import React from 'react'

import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'
import routes from 'Config/routes'

const MulticenterRoute = ({ children, ...rest }) => {
  const user = useSelector(({ auth }) => auth.user)
  const isMulticenter = useSelector(({ auth }) => !auth.hasOnlyOneCenter)

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (isEmpty(user)) {
          return (
            <Redirect
              to={{
                pathname: routes.root,
                state: { from: location },
              }}
            />
          )
        }

        if (!isMulticenter) {
          return (
            <Redirect
              to={{
                pathname: routes.home,
                state: { from: location },
              }}
            />
          )
        }

        return children
      }}
    />
  )
}

MulticenterRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default MulticenterRoute
